import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import "../styles.css";

const Dashboard = () => {
  const [stats, setStats] = useState({
    totalClinics: 0,
    totalPatients: 0,
    highRiskReports: 0,
  });

  const [recentPatients, setRecentPatients] = useState([]);

  useEffect(() => {
    // Demo analytics data (API-ready structure)
    const dashboardStats = {
      totalClinics: 10,
      totalPatients: 865,
      highRiskReports: 4,
    };

    const recentPatientsData = [
      {
        id: 1,
        name: "Sarah Connor",
        clinic: "MediCare Cape Town",
        status: "Active",
        risk: "Low",
      },
      {
        id: 2,
        name: "Michael Smith",
        clinic: "Sunrise Medical Centre",
        status: "Pending",
        risk: "Medium",
      },
      {
        id: 3,
        name: "Linda Brown",
        clinic: "Wellness Hub",
        status: "Inactive",
        risk: "High",
      },
      {
        id: 4,
        name: "Ahmed Khan",
        clinic: "Unity Care Clinic",
        status: "Active",
        risk: "Low",
      },
      {
        id: 5,
        name: "Rebecca Adams",
        clinic: "Riverbend Primary Care",
        status: "Active",
        risk: "Medium",
      },
    ];

    setStats(dashboardStats);
    setRecentPatients(recentPatientsData);
  }, []);

  const getBadgeClass = (type) => {
    switch (type) {
      case "Active":
        return "badge green";
      case "Pending":
        return "badge yellow";
      case "Inactive":
        return "badge red";
      case "Low":
        return "badge green";
      case "Medium":
        return "badge yellow";
      case "High":
        return "badge red";
      default:
        return "badge";
    }
  };

  return (
    <div className="layout">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Dashboard */}
      <div className="dashboard">
        <h1 className="dashboard-title">Welcome back 👋</h1>
        <p className="dashboard-sub">
          Healthcare system analytics and operational overview
        </p>

        {/* Stats Row */}
        <div className="stats-row">
          <div className="stat-card">
            <div className="stat-icon yellow">🏥</div>
            <div>
              <h3>Total Clinics</h3>
              <p className="stat-value">{stats.totalClinics}</p>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon blue">👥</div>
            <div>
              <h3>Total Patients</h3>
              <p className="stat-value">{stats.totalPatients}</p>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon red">⚠️</div>
            <div>
              <h3>High Risk Reports</h3>
              <p className="stat-value">{stats.highRiskReports}</p>
            </div>
          </div>
        </div>

        {/* Recent Patients Table */}
        <div className="table-card">
          <div className="table-header">
            <h2 className="section-title">Recent Patient Activity</h2>
            <button className="primary-btn">View All</button>
          </div>

          <table className="styled-table">
            <thead>
              <tr>
                <th>Patient</th>
                <th>Clinic</th>
                <th>Status</th>
                <th>Risk Level</th>
              </tr>
            </thead>

            <tbody>
              {recentPatients.map((p) => (
                <tr key={p.id}>
                  <td>{p.name}</td>
                  <td>{p.clinic}</td>
                  <td>
                    <span className={getBadgeClass(p.status)}>
                      {p.status}
                    </span>
                  </td>
                  <td>
                    <span className={getBadgeClass(p.risk)}>
                      {p.risk}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Future Expansion Area */}
        <div className="dashboard-widgets">
          <div className="widget-card">
            <h3>Clinic Performance</h3>
            <p>Analytics module (AI insights, KPIs, growth metrics)</p>
          </div>

          <div className="widget-card">
            <h3>System Alerts</h3>
            <p>Automated monitoring & compliance notifications</p>
          </div>

          <div className="widget-card">
            <h3>AI Risk Analysis</h3>
            <p>Predictive patient risk scoring (ML integration ready)</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;